import { bluePalette } from '../../../themes/colors';

export const primarySidenavLightTheme = {
  backgroundColor: bluePalette[1000],
};
